// ** React Imports
import React, { Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

// ** ApexCharts Import - necessário para react-apexcharts (versão IIFE)
import ApexCharts from 'apexcharts'

// ** PropTypes Import - necessário para react-apexcharts (versão IIFE)
import PropTypes from 'prop-types'

// ** Make React, ApexCharts and PropTypes available globally for react-apexcharts (IIFE version)
// Isso é crítico para react-apexcharts que espera React, ApexCharts e PropTypes como variáveis globais
// Deve ser feito ANTES de qualquer importação que use react-apexcharts
if (typeof window !== 'undefined') {
  window.React = React
  window.ApexCharts = ApexCharts
  window.PropTypes = PropTypes
}
// import socket from '../src/providers/socket'
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css'

// ** Redux Imports
import { store } from './redux/store'
import { Provider } from 'react-redux'

// ** Intl, CASL & ThemeColors Context
import ability from './configs/acl/ability'
import { AbilityContext } from './utility/context/Can'
import { ThemeContext } from './utility/context/ThemeColors'

// ** ThemeConfig
import themeConfig from './configs/themeConfig'

// ** Toast
import { Toaster } from 'react-hot-toast'

// ** i18n
import './configs/i18n'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** Fake Database
import './@fake-db'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Hot Toast Styles
import '@styles/react/libs/react-hot-toasts/react-hot-toasts.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

// ** Service Worker
import * as serviceWorker from './serviceWorker'
import newSocket from './providers/newSocket'

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
	<BrowserRouter>
		<Provider
			store={store}
			// socket={socket}
			newSocket={newSocket}
		>
			<Suspense fallback={<Spinner />}>
				<AbilityContext.Provider value={ability}>
					<ThemeContext>
						<LazyApp />
						<Toaster
							position={themeConfig.layout.toastPosition}
							toastOptions={{ className: 'react-hot-toast' }}
						/>
					</ThemeContext>
				</AbilityContext.Provider>
			</Suspense>
		</Provider>
	</BrowserRouter>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
